import { getDateFromOffset } from "../../utils/convert-date";
import { TERRAFORM_ENV_ID } from "../scenarios/edu-scenarios";

export const allS3Buckets = (
  departmentId,
  appId = "001",
  environmentId,
  accountNumber = "904433914959",
  regionCode = "us-east-1"
) => [
  {
    BucketName: "setup-elastic-search-20-elsbackuprepositorybucke-2jegbj8sql60",
    ResourceName:
      "setup-elastic-search-20-elsbackuprepositorybucke-2jegbj8sql60",
    Provider: "AWS",
    ResourceId:
      "arn:aws:s3:::setup-elastic-search-20-elsbackuprepositorybucke-2jegbj8sql60",
    Region: regionCode ? regionCode : "us-east-1",
    BucketRegion: regionCode ? regionCode : "us-east-1",
    DepartmentId: departmentId,
    EnvironmentId: environmentId,
    CreatedBy: null,
    ModifiedOn: "2019-10-03 09:16:51",
    CreatedAt: "2019-10-03 09:16:51",
    UpdatedAt: "2019-10-03 09:16:51",
    ResourceType: "S3",
    ResourceTags: [
      {
        Key: "aws:cloudformation:stack-name",
        Value: "Setup-Elastic-Search--2019-10-03--14-46-31",
      },
      {
        Key: "aws:cloudformation:stack-id",
        Value:
          "arn:aws:cloudformation:us-east-1:771592380081:stack/Setup-Elastic-Search--2019-10-03--14-46-31/81831830-e5be-11e9-b45d-0a28f59d0ab4",
      },
      { Key: "Environment", Value: "Dev" },
      {
        Key: "aws:cloudformation:logical-id",
        Value: "ELSBackupRepositoryBucket",
      },
      { Key: "Vendor", Value: "MontyCloud" },
      { Key: "ApplicationId", Value: "80e75ebb-077a-436e-af0a-0cd88390d658" },
      { Key: "Application", Value: "ECS-Cluster-Dev" },
    ],
    Domain: "Storage",
    AccountNumber: accountNumber ? accountNumber : "904433914959",
    OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
    ApplicationId: appId,
    CreatedOn: "2019-10-03 09:16:51",
    ModifiedBy: null,
    ARN: "arn:aws:cloudformation:us-east-1:771592380081:stack/Setup-Elastic-Search--2019-10-03--14-46-31/81831830-e5be-11e9-b45d-0a28f59d0ab4",
  },
  {
    BucketName: "custom-5ac67052-7484-backuprepositorybucke-joly4ufwt80b",
    ResourceName: "custom-5ac67052-7484-backuprepositorybucke-joly4ufwt80b",
    Provider: "AWS",
    ResourceId:
      "arn:aws:s3:::custom-5ac67052-7484-backuprepositorybucke-joly4ufwt80b",
    Region: regionCode ? regionCode : "us-east-1",
    BucketRegion: regionCode ? regionCode : "us-east-1",
    DepartmentId: departmentId,
    EnvironmentId: environmentId,
    CreatedBy: null,
    ModifiedOn: "2019-10-03 09:16:51",
    CreatedAt: "2019-10-03 09:16:51",
    UpdatedAt: "2019-10-03 09:16:51",
    ResourceType: "S3",
    ResourceTags: [
      {
        Key: "aws:cloudformation:stack-name",
        Value: "custom-5ac67052-7484-backuprepositorybucke-joly4ufwt80b",
      },
    ],
    Domain: "Storage",
    AccountNumber: accountNumber ? accountNumber : "904433914959",
    OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
    ApplicationId: appId,
    CreatedOn: "2019-10-03 09:16:51",
    ModifiedBy: null,
    ARN: "arn:aws:s3:::custom-5ac67052-7484-backuprepositorybucke-joly4ufwt80b",
  },
];

export const s3TerraformArray = [
  {
    BucketName: "prdatabucket1",
    ResourceName: "prdatabucket1",
    Provider: "AWS",
    ResourceId: "arn:aws:s3:::prdatabucket1",
    Region: "us-east-1",
    BucketRegion: "us-east-1",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    CreatedBy: null,
    ModifiedOn: getDateFromOffset(new Date(), -2),
    CreatedAt: getDateFromOffset(new Date(), -2),
    UpdatedAt: getDateFromOffset(new Date(), -2),
    ResourceType: "S3",
    ResourceTags: [
      {
        Key: "Service",
        Value: "Protein Research",
      },
    ],
    Domain: "Storage",
    AccountNumber: "904433914959",
    OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
    CreatedOn: getDateFromOffset(new Date(), -2),
    ModifiedBy: null,
    ARN: "arn:aws:s3:::prdatabucket1",
  },
  {
    BucketName: "prdatabucket2",
    ResourceName: "prdatabucket2",
    Provider: "AWS",
    ResourceId: "arn:aws:s3:::prdatabucket2",
    Region: "us-east-1",
    BucketRegion: "us-east-1",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    CreatedBy: null,
    ModifiedOn: getDateFromOffset(new Date(), -2),
    CreatedAt: getDateFromOffset(new Date(), -2),
    UpdatedAt: getDateFromOffset(new Date(), -2),
    ResourceType: "S3",
    ResourceTags: [
      {
        Key: "Service",
        Value: "Protein Research",
      },
    ],
    Domain: "Storage",
    AccountNumber: "904433914959",
    OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
    CreatedOn: getDateFromOffset(new Date(), -2),
    ModifiedBy: null,
    ARN: "arn:aws:s3:::prdatabucket2",
  },
  {
    BucketName: "prdatabucket3",
    ResourceName: "prdatabucket3",
    Provider: "AWS",
    ResourceId: "arn:aws:s3:::prdatabucket3",
    Region: "us-east-1",
    BucketRegion: "us-east-1",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    CreatedBy: null,
    ModifiedOn: getDateFromOffset(new Date(), -2),
    CreatedAt: getDateFromOffset(new Date(), -2),
    UpdatedAt: getDateFromOffset(new Date(), -2),
    ResourceType: "S3",
    ResourceTags: [
      {
        Key: "Service",
        Value: "Protein Research",
      },
    ],
    Domain: "Storage",
    AccountNumber: "904433914959",
    OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
    CreatedOn: getDateFromOffset(new Date(), -2),
    ModifiedBy: null,
    ARN: "arn:aws:s3:::prdatabucket3",
  },
  {
    BucketName: "elsproteinresearchsnapshotbucket",
    ResourceName: "elsproteinresearchsnapshotbucket",
    Provider: "AWS",
    ResourceId: "arn:aws:s3:::elsproteinresearchsnapshotbucket",
    Region: "us-east-1",
    BucketRegion: "us-east-1",
    DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
    Departments: ["98ea91b7-551f-4d35-a113-b37fcd840a71"],
    EnvironmentId: TERRAFORM_ENV_ID,
    CreatedBy: null,
    ModifiedOn: getDateFromOffset(new Date(), -2),
    CreatedAt: getDateFromOffset(new Date(), -2),
    UpdatedAt: getDateFromOffset(new Date(), -2),
    ResourceType: "S3",
    ResourceTags: [
      {
        Key: "Service",
        Value: "Protein Research",
      },
    ],
    Domain: "Storage",
    AccountNumber: "904433914959",
    OrganizationId: "03e4aa7a-c984-4178-a9be-017896865bec",
    ApplicationId: TERRAFORM_ENV_ID,
    Apps: [TERRAFORM_ENV_ID],
    CreatedOn: getDateFromOffset(new Date(), -2),
    ModifiedBy: null,
    ARN: "arn:aws:s3:::elsproteinresearchsnapshotbucket",
  },
];
